<template>
  <div>
    <!-- <div class="no-display">
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box">
        <v-toolbar flat dense class="toolbar no-display">
          <v-toolbar-title>Pay Sheet Summary Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense class="no-display">
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" :items="employee_type_list"
              item-text="name" item-value="id" label="Employee Type" outlined @change="paysheetreport=''" />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <v-autocomplete color="#0F2027" dense rounded required multiple v-model="section" :items="section_list"
              item-text="name" item-value="id" label="Employee Section" outlined @change="paysheetreport=''" />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list" item-text="name"
              item-value="id" label="Salary Year" outlined @change="getSalaryMonth();paysheetreport=''" />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3" v-if="year">
            <v-autocomplete color="#0F2027" dense rounded required multiple v-model="sal_month" :items="sal_month_list"
              item-text="sal_mon" item-value="id" label="Salary Month" outlined @change="paysheetreport=''" />
          </v-col>
          <v-col cols="12" sm="8" md="5" v-if="sal_month != ''" align="center">
            <!-- <center> -->
            <v-btn class="button" @click="fetchReport()" :loading="loader">Fetch Complete Summary Report</v-btn>
            <!-- </center> -->
          </v-col>
        </v-row>
        <v-row v-if="paysheetreport != ''" dense justify="center">
          <!-- excel btn code -->
          <v-row class="ml-2 no-display ">
            <v-col cols="12" sm="2" md="2">
              <v-btn class="ma-2 no-display" rounded color="success" outlined
                @click="fnExcelReport('my-table-id', 'PaySheetSummaryReport')" :loading="loader"><v-icon
                  color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-btn class="ma-2 no-display " rounded tile outlined color="warning" @click="print()">
                <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <!-- {{paysheetreport}} -->

          <v-col cols="12" sm="12" md="12">
            <div id="my-table-id">
              <!-- header code -->
              <v-simple-table></v-simple-table>
              <div v-if="org_basic_data">
                <v-row dense justify="center">
                  <v-col cols="12" sm="4" md="8">
                    <center>
                      <h2>
                        <strong>{{ org_basic_data.trust_name }}</strong>
                      </h2>
                      <h3>
                        <strong>{{ org_basic_data.school_name }} </strong>
                      </h3>
                    </center>
                  </v-col>
                </v-row>
              </div>
              <div>
                <center>
                  <strong>Pay Sheet Summary Report [{{computed_getSalMonth}}]</strong>
                </center>
              </div>
              <!-- header end -->
              <v-simple-table fixed-header dense class="elevation-1">
                <thead>
                  <tr class="toolbar">
                    <td align="center">Sr. No.</td>
                    <td align="center">Employee Section</td>
                    <td align="center">Employee Type</td>
                    <td align="center">No. Of Employees</td>
                    <td align="center" v-for="(header, index) in comp_header" :key="index">
                      {{ header }}
                    </td>
                    <td align="center">Gross Salary</td>
                    <td align="center" v-for="(header, index) in comp_header_dedu" :key="index">
                      {{ header }}
                    </td>
                    <td align="center">Gross Deduction</td>
                    <td align="center">Net Salary</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(s, index) in paysheetreport" :key="index">
                    <td align="">{{ index + 1 }}</td>
                    <td align="">{{ s.es_name }}</td>
                    <td align="">{{ s.et_name }}</td>
                    <td>
                      <center>{{ s.inst_size }}</center>
                    </td>
                    <td v-for="(comp, index) in s.amount_list" :key="index">
                      <center>
                        {{ comp }}
                      </center>
                    </td>
                    <td>
                      <center>{{ s.grosssal[0] }}</center>
                    </td>
                    <td v-for="(comp, index) in s.amount_list_dedu" :key="index">
                      <center>
                        {{ comp }}
                      </center>
                    </td>
                    <td>
                      <center>{{ s.grossdeduction[0] }}</center>
                    </td>
                    <td>
                      <center>{{ s.netsal[0] }}</center>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <center>{{ total_inst }}</center>
                    </td>
                    <td v-for="(comp, index) in amount_list_final" :key="index">
                      <center>
                        {{ comp }}
                      </center>
                    </td>
                    <td>
                      <center>{{ grosssalary }}</center>
                    </td>
                    <td v-for="(comp, index) in amount_list_final_dedu" :key="index">
                      <center>
                        {{ comp }}
                      </center>
                    </td>
                    <td>
                      <center>{{ grossdeductions }}</center>
                    </td>
                    <td>
                      <center>{{ netsalary }}</center>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    extraBreadcrumbItems: [
      

    ],
    breadcrumbClass: "breadcrumb-style1",
    title: "",
    description: "",
    sal_month_list: [],
    sal_month: [],
    comp_header: [],
    emp_salary_reg_detail: [],
    year: null,
    year_list: [],
    freez_flag: null,
    fmsg: null,
    employee_type_list: [],
    employee_type: null,
    paysheetreport: [],
    comp_header: [],
    comp_header_dedu: [],
    total_inst: null,
    netsalary: null,
    grosssalary: null,
    grossdeductions: null,
    amount_list_final: [],
    amount_list_final_dedu: [],
    section_list: [],
    section: [],
    org_basic_data: null,
  }),
  computed: {
    computed_getSalMonth:function(){
      for (var i = 0; i < this.sal_month_list.length; i += 1) {
        console.log(this.sal_month_list[i].id)
        console.log(this.sal_month)
        if (this.sal_month_list[i].id == this.sal_month) {
          return this.sal_month_list[i].sal_mon;
        }
      }
    },
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    fetchReport() {
      const data = {
        sal_month: this.sal_month,
        employee_type: this.employee_type,
        section: this.section,
      };
      this.loader = true
      axios
        .post("/Payroll/paySheetSummaryReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.comp_header = res.data.comp_header;
            this.comp_header_dedu = res.data.comp_header_dedu;
            this.paysheetreport = res.data.paysheetreport;
            this.total_inst = res.data.total_inst;
            this.netsalary = res.data.netsalary;
            this.grosssalary = res.data.grosssalary;
            this.grossdeductions = res.data.grossdeductions;
            this.amount_list_final = res.data.amount_list_final;
            this.amount_list_final_dedu = res.data.amount_list_final_dedu;
            this.org_basic_data = res.data.org_basic_data;
            if(this.paysheetreport==''){
              this.showSnackbar("#b71c1c", "No Data Found!!!");
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
           this.loader = false
        })
        .catch((error) => {
          window.console.log(error);
          this.loader = false
        })
        .finally(() => {
          this.loader = false
        });
    },
    onLoad() {
      axios
        .post("/Payroll/getYear")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.employee_type_list = res.data.employee_type_list;
            this.year_list = res.data.year_list;
            this.section_list = res.data.section_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },
    getSalaryMonth() {
      const data = {
        year: this.year,
      };
      axios
        .post("/Payroll/getSalaryMonth", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.sal_month_list = res.data.sal_month_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
thead {
  font-weight: bold !important;
}

th {
  font-weight: bold !important;
}

tr,
td,
th {
  border: 1px solid black;
  /* text-align: center; */
  font-size: small;
}

tr,
tbody {
  border-bottom: 1px solid black;
  border: 1px solid black;
  font-size: small;
}

td {
  font-size: small;
}

@media (min-width: 320px) {

  td,
  th {
    display: table-cell !important;
    font-size: small;
  }

  td+td,
  th+th {
    width: auto;
    font-size: small;
  }
}

v-simple-table {
  white-space: nowrap !important;
  /* text-align: center; */
  font-size: small;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

@media print {
  /* ✅ Use full landscape width */
  @page {
    size: A4 landscape;
    margin: 10mm;
  }

  /* ✅ Show only report area */
  body * {
    visibility: hidden !important;
  }

  #my-table-id, 
  #my-table-id * {
    visibility: visible !important;
  }

  #my-table-id {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
  }

  /* ✅ Force Vuetify wrappers to expand */
  .v-data-table__wrapper,
  .v-table__wrapper,
  .v-simple-table > div {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
    width: 100% !important;
  }

  /* ✅ Make table fill available width */
  table {
    width: 100% !important;
    border-collapse: collapse !important;
    table-layout: auto !important;
  }

  td, th {
    white-space: nowrap !important;
    page-break-inside: avoid !important;
    font-size: 11pt !important;
    padding: 4px !important;
  }
}


</style>

